export default {
  yourSkills: "Ihre Kompetenzen",
  skills: "Kompetenzen",
  skill: "Kompetenz",
  last_skill_update: "Letzte Speicherung",
  duration: "Dauer",
  Category: "Kategorie",
  "Skills saved successfully": "Kompetenzen erfolgreich gespeichert",
  next: "Nächste",
  previous: "Vorherige",
  seeHistoric: "Verlauf anzeigen",
  resetSkill: "Kompetenz zurücksetzen",
  justificativePieceSend: "Belege gesendet",
  sendJustificativePiece: "Belege senden",
  impossibleJustificativeSending: "Belege können erst nach der Benotung hinzugefügt werden",
  stats: {
    no_data: "Noch keine Daten eingegeben",
  },
  no_skills: "Für diese Kategorie ist keine Kompetenz eingetragen",
  no_skill_available: "Derzeit ist keine Kompetenz eingetragen",
  no_skill_complete: "Keine Kompetenz wurde ausgefüllt",
  skill_chart: "Kompetenzdiagramm",
  skill_chart_pdf_name: "kompetenz-diagramm",
  referential_visible: ({ plural }) => plural(["Referential aktiv", "Referential inaktiv"]),
  session_visible: ({ plural }) => plural(["Sitzung aktiv", "Sitzung inaktiv"]),
  generate_all_rncp_referential: "Alle France Compétences-Referentiale generieren",
  empty_config: "Achtung: Die Konfiguration des Kompetenzmoduls ist noch nicht abgeschlossen",
  admin_config: {
    enable_on_all_training_course: {
      title: "Admin-Konfiguration auf alle aktiven Gruppen anwenden",
      confirm: {
        title: "Admin-Konfiguration verwenden?",
        subtitle:
          "Achtung: Dies betrifft die Admin-Konfiguration auf alle aktiven Gruppen, auch solche mit einer personalisierten Konfiguration",
      },
    },
    disable_on_all_training_course: {
      title: "Personalisierte Konfiguration auf alle aktiven Gruppen anwenden",
      confirm: {
        title: "Personalisierte Konfiguration verwenden?",
        subtitle:
          "Achtung: Dies betrifft die personalisierte Konfiguration auf alle aktiven Gruppen, auch solche mit der Admin-Konfiguration",
      },
    },
    gradingScale: "Bewertungsskala",
  },
  skill_admin_config_in_use: "Sie verwenden derzeit die Admin-Konfiguration für die Zeiträume.",
  notEvaluable: "Nicht bewertbar",
};
